import { useState, useEffect } from "react";
import api from "../../api/axios"; 
import "./Settings.css";
import { toast } from "react-toastify";

function UserRole() {
  const [roles, setRoles] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [canWrite, setCanWrite] = useState(false);
  const [editingRoleId, setEditingRoleId] = useState(null);
  const [showNamePopup, setShowNamePopup] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
const [roleToDelete, setRoleToDelete] = useState(null);

  // ✅ PRESERVED ALL OLD KEYS + ADDED NEW SETTINGS KEYS
  const [newRole, setNewRole] = useState({
    name: "",
    description: "",
    permissions: {
      agent: { read: false, write: false },
      dashboard: { read: false, write: false },
      kb: { read: false, write: false },
      artifacts: { read: false, write: false },
      analytics: { read: false, write: false },
      logs: { read: false, write: false },
      profile: { read: false, write: false },
      workspace_mgmt: { read: false, write: false },
      user_role: { read: false, write: false },
      notifications: { read: false, write: false },
      subscription: { read: false, write: false }
    },
  });

  useEffect(() => {
    fetchDbRoles();
    fetchUserPermissions(); 
  }, []);

  const fetchUserPermissions = async () => {
    try {
      const res = await api.get("/user-roles/me");
      const data = res.data;

      if (data.isAdmin) {
        setCanWrite(true);
        return;
      }
      if (data && !data.noRoleDefined) {
        const hasPerm = (data.write_access || "").includes("User Role") || 
                        (data.both_access || "").includes("User Role");
        setCanWrite(hasPerm);
      }
    } catch (err) {
      console.error("Permission check failed");
      setCanWrite(false);
    }
  };

  const fetchDbRoles = async () => {
    try {
      const response = await api.get("/user-roles");
      // Add defaults if table is empty for visual context
      if(response.data.length === 0) {
        setRoles([
          { id: 1, role_name: "Admin", description: "Management level access with most permissions" },
          { id: 2, role_name: "Viewer", description: "Can only chat with the agents" },
        ]);
      } else {
        setRoles(response.data); 
      }
    } catch (err) {
      console.error("Error fetching roles from DB");
      setRoles([]); 
    }
  };

  const handleEditClick = (role) => {
    if (role.id === 1 || role.id === 2 || role.role_id === 1 || role.role_id === 2) return;

    const resetPerms = { ...newRole.permissions };
    Object.keys(resetPerms).forEach(k => resetPerms[k] = { read: false, write: false });

    const map = { 'Kb':'kb', 'Analytics':'analytics', 'Dashboard':'dashboard', 'Artifacts':'artifacts', 'Logs':'logs', 'Agent':'agent', 'Profile Management':'profile', 'Workspace Management':'workspace_mgmt', 'User Role':'user_role', 'Notifications':'notifications', 'Subscription':'subscription' };
    
    const both = (role.both_access || "").split(", ");
    const read = (role.read_access || "").split(", ");
    const write = (role.write_access || "").split(", ");

    Object.entries(map).forEach(([label, key]) => {
      if (both.includes(label)) resetPerms[key] = { read: true, write: true };
      else if (read.includes(label)) resetPerms[key] = { read: true, write: false };
      else if (write.includes(label)) resetPerms[key] = { read: false, write: true };
    });

    setNewRole({
      name: role.role_name || role.name,
      description: role.description,
      permissions: resetPerms
    });
    setEditingRoleId(role.role_id);
    setShowModal(true);
  };

  const handleDeleteRole = async () => {
  try {
    await api.delete(`/user-roles/${roleToDelete}`);

    toast.success("Role deleted successfully");

    fetchDbRoles();

    setShowDeleteModal(false);
    setRoleToDelete(null);

  } catch (err) {
    toast.error("Delete failed");
  }
};

  const handlePermissionChange = (page, type) => {
    setNewRole((prev) => {
      const current = { ...prev.permissions[page] };
      let newRead = current.read;
      let newWrite = current.write;

      if (type === "write") {
        newWrite = !current.write;
        if (newWrite === true) newRead = true;
      } else {
        newRead = !current.read;
        if (newRead === false) newWrite = false;
      }

      return {
        ...prev,
        permissions: {
          ...prev.permissions,
          [page]: { read: newRead, write: newWrite },
        },
      };
    });
  };

  const handleAddRole = async () => {
    if (!canWrite) return; 

    const payload = {
      role_name: newRole.name,
      description: newRole.description,
      permissions: newRole.permissions 
    };

    try {
      let response;
      if (editingRoleId) {
        response = await api.put(`/user-roles/${editingRoleId}`, payload);
      } else {
        response = await api.post("/user-roles", payload);
      }
      
      if (response.status === 201 || response.status === 200) {
        setShowModal(false);
        setEditingRoleId(null);
        fetchDbRoles(); 
        
        setNewRole({
          name: "", 
          description: "",
          permissions: { 
            agent: { read: false, write: false }, 
            dashboard: { read: false, write: false }, 
            kb: { read: false, write: false },
            artifacts: { read: false, write: false }, 
            analytics: { read: false, write: false },
            logs: { read: false, write: false },
            profile: { read: false, write: false },
            workspace_mgmt: { read: false, write: false },
            user_role: { read: false, write: false },
            notifications: { read: false, write: false },
            subscription: { read: false, write: false }       
          },
        });
      }
    } catch (err) {
  toast.error(
  err.response?.data?.message || "Operation failed"
);
    }
  };

  const getDisplayLabel = (key) => {
    const labels = {
      kb: 'Kb', profile: 'Profile Management', workspace_mgmt: 'Workspace Management',
      user_role: 'User Role', notifications: 'Notifications', subscription: 'Subscription'
    };
    return labels[key] || key.charAt(0).toUpperCase() + key.slice(1);
  };

  const popupStyle = {
    position: 'absolute', bottom: '-32px', left: '10px', backgroundColor: '#1a73e8', 
    color: '#fff', padding: '4px 12px', borderRadius: '6px', fontSize: '11px',
    fontWeight: '500', zIndex: 9999, whiteSpace: 'nowrap', boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
    pointerEvents: 'none'
  };

  return (
    <div className="ur-container w-100">
      {/* 🔥 Reduced card padding from p-4 to p-3 to make it sleeker */}
      <div className="card border-0 shadow-sm rounded-4 mb-4 p-3 w-100">
        
        {/* ── HEADER ── */}
        <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
          <h6 className="fw-bold mb-0 text-dark" style={{ fontSize: "16px" }}>Active System Roles</h6>
          {canWrite && (
            <button
              className="btn btn-primary fw-bold border-0 shadow-sm"
              /* 🔥 Massively reduced button height and width */
              style={{ fontSize: "12px", padding: "6px 16px", borderRadius: "6px" }}
              onClick={() => { setEditingRoleId(null); setShowModal(true); }}
            >
              Add New
            </button>
          )}
        </div>

        {/* ── POLISHED COMPACT TABLE MATCHING DESIGN ── */}
        <div className="w-100" style={{ overflow: 'visible' }}>
          <table className="table ur-modern-table align-middle mb-0 w-100">
           <thead>
  <tr>
    <th className="ps-3">ROLE NAME</th>
    <th>DESCRIPTION</th>
    {canWrite && <th className="text-end pe-3"></th>}
  </tr>
</thead>
            <tbody>
              {roles.map((role) => {
                const isSystemRole = role.id === 1 || role.id === 2 || role.role_id === 1 || role.role_id === 2;
                
                return (
<tr key={role.id || role.role_id}>
  {/* Role Name */}
  <td className="fw-bold text-dark ps-3" style={{ fontSize: "13px" }}>
    <div className="d-flex align-items-center gap-2">
      <span className={`ur-role-dot ${isSystemRole ? "bg-primary" : "bg-secondary opacity-50"}`}></span>
      {role.name || role.role_name}
    </div>
  </td>

  {/* Description */}
  <td className="text-muted" style={{ fontSize: "13px" }}>
    {role.description}
  </td>
                    
                    {/* Actions */}
                    {canWrite && (
                      <td className="text-end pe-3">
                        {!isSystemRole ? (
                         <div className="d-flex justify-content-end gap-3">
  <img
    src="/images/useeye.svg"
    alt="View"
    className="ur-action-icon"
    onClick={() => handleEditClick(role)}
  />

  <img
    src="/images/usepen.svg"
    alt="Edit"
    className="ur-action-icon"
    onClick={() => handleEditClick(role)}
  />

  <img
    src="/images/usebin.svg"
    alt="Delete"
    className="ur-action-icon ur-delete-icon"
  onClick={() => {
  setRoleToDelete(role.role_id);
  setShowDeleteModal(true);
}}
  />
</div>
                        ) : (
                         <div
  className="d-flex justify-content-end gap-3 opacity-25"
  style={{ pointerEvents: "none" }}
>
  <img src="/images/useeye.svg" alt="View" className="ur-action-icon" />

  <img src="/images/usepen.svg" alt="Edit" className="ur-action-icon" />

  <img src="/images/usebin.svg" alt="Delete" className="ur-action-icon" />
</div>
                        )}
                      </td>
                    )}
                  </tr>
                );
              })}
             {roles.length === 0 && (
    <tr><td colSpan="3" className="text-center text-muted py-3">No roles found.</td></tr>
)}
            </tbody>
          </table>
        </div>
      </div>

      {/* ── MODAL ── */}
      {showModal && (
        <div className="wm-modal-overlay" onClick={() => setShowModal(false)}>
        <div className="wm-modal-content shadow-lg bg-white p-3" onClick={e => e.stopPropagation()}>
            
<div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
                <h6 className="fw-bold mb-0 text-dark">{editingRoleId ? "Update Role" : "Add New Role"}</h6>
              <i className="bi bi-x-lg cursor-pointer text-muted" onClick={() => setShowModal(false)}></i>
            </div>

          <div className="text-start mb-2 position-relative">
              <label className="form-label text-muted fw-medium mb-1" style={{fontSize: "11px"}}>Role Name*</label>
              {showNamePopup && <div style={popupStyle}>Max 20 characters only</div>}
              <input
                className="form-control form-control-sm modal-input"
                placeholder="Enter Name"
                maxLength={20}
                onFocus={() => setShowNamePopup(true)}
                onBlur={() => setShowNamePopup(false)}
                value={newRole.name}
                onChange={(e) => setNewRole({ ...newRole, name: e.target.value })}
              />
            </div>

            <div className="text-start mb-3">
              <label className="form-label text-muted fw-medium mb-1" style={{fontSize: "11px"}}>Description*</label>
              <textarea
                className="form-control form-control-sm modal-input"
                rows="2"
                placeholder="Enter Description"
                value={newRole.description}
                onChange={(e) => setNewRole({ ...newRole, description: e.target.value })}
              />
            </div>

          <div className="text-start mb-2">
             <label className="form-label text-muted fw-bold mb-1" style={{fontSize: "11px"}}>Permissions</label>
  <div className="border rounded p-1" style={{ maxHeight: "140px", overflowY: "auto" }}>
                <table className="table table-sm align-middle mb-0 border-0">
                  <thead>
                    <tr>
                      <th className="text-muted fw-semibold border-0 py-1" style={{fontSize: "10px"}}>Page / Section</th>
                      <th className="text-muted fw-semibold border-0 text-center py-1" style={{fontSize: "10px"}}>Read</th>
                      <th className="text-muted fw-semibold border-0 text-center py-1" style={{fontSize: "10px"}}>Write</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(newRole.permissions).map((page) => (
                      <tr key={page} className="border-bottom">
                        <td className="text-capitalize fw-medium text-dark border-0 py-1" style={{fontSize: "12px"}}>
                          {getDisplayLabel(page)}
                        </td>
                        <td className="text-center border-0 py-1">
                          <input type="checkbox" className="form-check-input mt-0" checked={newRole.permissions[page].read} onChange={() => handlePermissionChange(page, "read")} style={{transform:'scale(0.85)'}} />
                        </td>
                        <td className="text-center border-0 py-1">
                          <input type="checkbox" className="form-check-input mt-0" checked={newRole.permissions[page].write} onChange={() => handlePermissionChange(page, "write")} style={{transform:'scale(0.85)'}} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

       <div className="d-flex gap-2 mt-1">
              <button className="btn btn-sm btn-outline-secondary flex-grow-1 fw-bold" onClick={() => setShowModal(false)}>Cancel</button>
              <button className="btn btn-sm btn-primary flex-grow-1 fw-bold" onClick={handleAddRole}>
                {editingRoleId ? "Save Changes" : "Add Role"}
              </button>
            </div>

          </div>
        </div>
      )}
      {showDeleteModal && (
  <div
    className="modal fade show d-block"
    onClick={() => {
      setShowDeleteModal(false);
      setRoleToDelete(null);
    }}
    style={{
      background: "rgba(0,0,0,0.45)",
      zIndex: 9999,
    }}
  >
    <div className="modal-dialog modal-dialog-centered">
      <div
        className="modal-content border-0"
        onClick={(e) => e.stopPropagation()}
        style={{
          borderRadius: "18px",
          overflow: "hidden",
        }}
      >
        <div className="modal-body text-center p-4">
          <div
            style={{
              width: "68px",
              height: "68px",
              background: "#FEECEC",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 18px",
            }}
          >
            <i
              className="bi bi-trash3"
              style={{
                color: "#ef4444",
                fontSize: "28px",
              }}
            ></i>
          </div>

          <h5
            style={{
              fontWeight: 700,
              marginBottom: "10px",
            }}
          >
            Delete Role?
          </h5>

          <p
            style={{
              color: "#6b7280",
              fontSize: "14px",
              marginBottom: "26px",
            }}
          >
            This action cannot be undone.
          </p>

          <div className="d-flex justify-content-center gap-3">
            <button
              className="btn btn-light px-4"
              onClick={() => {
                setShowDeleteModal(false);
                setRoleToDelete(null);
              }}
            >
              Cancel
            </button>

            <button
              className="btn btn-danger px-4"
              onClick={handleDeleteRole}
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
)}
    </div>
  );
}

export default UserRole;